import { render, staticRenderFns } from "./CreateEntryButton.vue?vue&type=template&id=8b2f65b6&"
import script from "./CreateEntryButton.vue?vue&type=script&lang=js&"
export * from "./CreateEntryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports